module.exports = __webpack_public_path__ + "static/PAQUETERIA1-7f696b1e71e80dd3bb52f52767c8319a.svg";